module.exports = __webpack_public_path__ + "img/ticket-success.bf3ea0e2.png";